import "../../utils/tailwind.css";
import { forwardRef } from "react";
import Form from "react-bootstrap/Form";
import cx from "../../utils/tailwind-merge";
import SearchIcon from "../svg/search";
import FormError from "../form-error";
import { useField, useFormikContext } from "formik";

const Input = forwardRef((props, ref) => {
  const { placeholder = "", className = "", rootClassName = "", showSearchIcon = false, leftIcon, rightIcon, ...rest } = props;

  const getSearchIcon = () => {
    if (leftIcon) return leftIcon;
    return <SearchIcon className="absolute left-3 top-[19px] transform -translate-y-1/2 text-gray-400" />;
  };

  return (
    <div className={cx("relative w-80", rootClassName)}>
      {showSearchIcon && getSearchIcon()}
      <Form.Control
        ref={ref}
        className={cx(
          "!bg-white !border-1 !pl-10 !text-[16px] !h-[48px] !p-[12px]",
          className,
        )}
        placeholder={placeholder}
        {...rest}
      />
      {rightIcon && rightIcon}
    </div>
  );
});

Input.displayName = "Input";

export default Input;

export function FormikInput(props) {
  const { name, classNames = {}, setRef = () => {} } = props;
  const [field, meta] = useField(name);
  const { submitCount, validateOnChange, touched } = useFormikContext();
  const isError = (validateOnChange && touched[name]) || (submitCount > 0 && !!meta.error);
  const helperText = validateOnChange && touched[name] ? meta.error : (submitCount > 0 && meta.error) || "";

  return (
    <>
      <Input ref={setRef} error={isError} {...field} {...props} />
      <FormError show={isError} message={helperText} className={classNames.error} />
    </>
  );
}
